module.exports = __webpack_public_path__ + "static/media/CBR-product-img.4992fb9c.png";